const ToTop = (url) => (
    <a href="#top" className="uk-icon-button uk-toptop-fd uk-animation-fade" uk-icon="icon: chevron-up; ratio: 1.5;" uk-scroll="offset: 500;" id="totop"></a>
);

export default ToTop;